import React from 'react'; 
import { Typography } from 'antd';
import FilteredImage from '../FilteredImage/FilteredImage';
import './styles.less';

const BannerSimple = ( { text = '', description = '', tall = false } ) => {
    return (   
        <div 
            role="contentinfo" 
            className={ `banner-simple-view ${ tall && 'tall' }` }
        >
            <FilteredImage >
                <div className="banner-content">
                    <h1>{ text }</h1>

                    { description && 
                        <Typography.Paragraph 
                            className="description" 
                            ellipsis={ { rows: 5, expandable: false } }
                        >
                            <span dangerouslySetInnerHTML={ { __html: description } }/>
                        </Typography.Paragraph>
                      }
                </div>
            </FilteredImage> 
        </div>
    );
};

export default BannerSimple;
